import React from "react";
import T from "prop-types";
import { isEmpty } from "lodash";
import { Warning } from "MODULES/shared/components";

const PartHazmatWarning = ({ hazmat, hazmatFee }) =>
  hazmat &&
  isEmpty(hazmatFee) && (
    <Warning warningType="danger">
      Part labeled as HazMat. Please consider HazMat Fee.
    </Warning>
  );

PartHazmatWarning.propTypes = {
  hazmat: T.bool,
  hazmatFee: T.number
};

export default PartHazmatWarning;



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/PartHazmatWarning.jsx